import { create } from 'zustand';
import { ChatState, Message } from '../types';
import { v4 as uuidv4 } from 'uuid';

export const useChatStore = create<ChatState>((set) => ({
  messages: [],
  isLoading: false,
  error: null,
  sessionId: null,
  suggestions: [],
  
  addMessage: (message) => set((state) => ({
    messages: [...state.messages, message]
  })),
  
  setLoading: (loading) => set({ isLoading: loading }),
  
  setError: (error) => set({ error }),
  
  setSessionId: (id) => set({ sessionId: id }),
  
  setSuggestions: (suggestions) => set({ suggestions }),
  
  clearChat: () => set({
    messages: [],
    error: null,
    suggestions: []
  }),
}));